const dataSetType = {
    STATIC : 0,

    CUSTOM : 1,

    PRODUCT_FIELD_DEPENDENT : 2,

    REPEATING_FORM : 3,

    STATIC_STRING : 'Static',

    CUSTOM_STRING : 'Custom',

    PRODUCT_FIELD_DEPENDENT_STRING : 'Product/Field Dependent',

    REPEATING_FORM_STRING : 'Repeating Form'

};

angular.module('gw-um-j2js')
    .constant('dataSetType', dataSetType);